var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('InfoDisplay',{attrs:{"version":_vm.system.versionInfo,"latest":_vm.releases.releases[0],"server":_vm.system.serverInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }